/* template */
<template><drawer-bottom :show="(show)" @close="close" :custom-class='["es-filling"].join(" ")'><div border slot="header"><div class="es-filling__drawer-header"><div class="es-filling__drawer-header-title">姓名填写说明</div><mpx-view @tap="close" class="es-filling__drawer-header-right"><es-icon size="24" color="#999999" name="close-filled" class="es-filling__drawer-close"></es-icon></mpx-view></div></div><div custom-main="es-content__miniapp_card_header" class="es-filling__drawer-content"><div class="tab"><mpx-view v-for="(item, index) in (tabArr)" :key="(index)" @tap="onChange(item.key)" :class="(activeKey == item.key ? 'tab-item-active' : 'tab-item')"><div>{{item.title}}</div><div class="tab-line" v-if="(activeKey == item.key)"></div></mpx-view></div><div :style='["height: 58px"] | transRpxStyle'></div><mpx-scroll-view scroll-y scroll-with-animation :scroll-into-view="(toTitle)" :style='["height: calc(100% - 48px)"] | transRpxStyle' @scroll="handleScroll"><div class="content"><div id="block-1"><div :class='("h1 "+("web" === "web"?"frist-title":""))'>姓名</div><div>乘客姓名需要与所持证件上的名字一致</div><div>若用户所选证件无中文姓名，请直接填写英文姓名</div><div class="h2">护照预订</div><div>中国护照用户请填写证件上的中文姓名，外籍护照请填写证件上的英文姓名。</div><div class="h2">生僻字</div><div>生僻字可用拼音、同音字代替。</div><div class="h2">特殊符号</div><div>姓名中含特殊符号“·”“.”等，请正常输入，若含有“-”“，”可转换成空格输入。</div><div class="h2">港澳台</div><div>香港、澳门、台湾的护照不支持国内航班，预订国内航班时请改用其他证件。</div><div class="h2">姓名较长</div><div>姓名较长需按姓名第一个汉字或英文字符开始按顺序连续输入，其中英文字符输入时不区分大小写。</div></div><div v-for="(item, index) in (image_arr)"><div :id='("block-"+(item.number))'><div class="h1">{{item.title}}</div><div :style='[("height:"+(windowHeight)+"px;width:"+(windowWidth)+"px")] | transRpxStyle' class="flex-box"><mpx-image :src="(item.imageSrc)" class="image"/></div></div></div></div></mpx-scroll-view></div></drawer-bottom></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m10da3b8e"}'>
  +b('filling')
    /deep/ .drawer-container
      height auto
    /deep/ .drawer-main
      height auto
    +e('drawer-header')
      display flex
      height 60px
      border-bottom 1px solid #eeeeee
      align-items center
    +e('drawer-header-title')
      flex 1
      text-align center
      font-size 16px
      font-weight 500
      margin-left 56px
    +e('drawer-header-right')
      width 56px
      text-align center
    +e('drawer-header-close')
      color #999999
    +e('drawer-content')
      display flex
      flex-direction column
      height calc(80vh - 60px)
      .tab
        display -webkit-box
        overflow-y hidden
        width calc(100% - 16px)
        height 48px
        line-height 45px
        position fixed
        z-index 2
        background #ffffff
        padding-bottom 10px
      .mpx-scroll-view
        flex 1
      .tab-item
      .tab-item-active
        padding 0 14px
        color #333333
        font-size 14px
        min-width 48px
        display flex
        flex-direction column
        align-items center
        font-family PingFangSC-Regular
        &:first-child
          padding-left 0
      .tab-item-active
        font-family PingFangSC-Medium
      .tab-line
        width 44px
        height 3px
        background-color #1473ff
      .content
        overflow-y auto
        color #333333
        font-size 14px
        flex 1
        padding-bottom 80px
        .h1
          font-size 16px
          font-weight bold
          padding 12px 0
        .frist-title
          padding-top 0
        .h2
          font-weight 500
          padding 12px 0
        .flex-box
          display flex
          justify-content center
        .image
          height 100%
          width 100%
    +e('drawer-footer')
      padding 16px 12px
      background-color #ffffff
      /deep/ .es-button
        border-radius 8px
    .set-padding
      padding-bottom 8px
    .word-break
      word-break break-all
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m10da3b8e"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex10da3b8e%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex10da3b8e%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m10da3b8e"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index10da3b8e/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-button':getComponent(require("../../../../../node_modules/@didi/es-mpx-ui/lib/button/index.mpx?isComponent&outputPath=components%2Findexbc68cb48%2Findex")),'es-popup':getComponent(require("../../../../../node_modules/@didi/es-mpx-ui/lib/popup/index.mpx?isComponent&outputPath=components%2Findex9216a4d4%2Findex")),'es-icon':getComponent(require("../../../../../node_modules/@didi/es-mpx-ui/lib/icon/index.mpx?isComponent&outputPath=components%2Findex6fe48a3a%2Findex")),'drawer-bottom':getComponent(require("../drawer-bottom/index.mpx?isComponent&outputPath=components%2Findex06b5b816%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-scroll-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-scroll-view.vue?isComponent"), { __mpxBuiltIn: true }),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
